import React, {Fragment} from "react";
import {Button, Form} from "react-bootstrap";
import Icon from "../Icon";
import ils_chat from "../../../assets/svg/ils/ils-chat.svg";
import "../../../assets/sass/components/messages/chat-blank-comment.scss";

class ChatGroupBlankParticipants extends React.Component {

    render() {
        return (
            <div className="chat-blank-content-wrapper">
                <div className="chat-blank-content">
                    <Icon svg={ils_chat}/>
                    <h4>No Conversations Yet</h4>
                    <p>No Messages in this group yet, Start coversation with all participants</p>
                </div>
            </div>
        )
    }
}

export default ChatGroupBlankParticipants;
